const dateToTime = date => ({
  hour: date.getHours(),
  minute: date.getMinutes(),
})

export default dateToTime
